// Reference data shared between member profile + directory.

export const MBTI_TYPES = [
  "INTJ", "INTP", "ENTJ", "ENTP",
  "INFJ", "INFP", "ENFJ", "ENFP",
  "ISTJ", "ISFJ", "ESTJ", "ESFJ",
  "ISTP", "ISFP", "ESTP", "ESFP",
];

// Official 16personalities.com Portuguese names per type.
export const MBTI_NAMES_PT = {
  INTJ: "Arquiteto",
  INTP: "Lógico",
  ENTJ: "Comandante",
  ENTP: "Inovador",
  INFJ: "Advogado",
  INFP: "Mediador",
  ENFJ: "Protagonista",
  ENFP: "Ativista",
  ISTJ: "Logístico",
  ISFJ: "Defensor",
  ESTJ: "Executivo",
  ESFJ: "Cônsul",
  ISTP: "Virtuoso",
  ISFP: "Aventureiro",
  ESTP: "Empresário",
  ESFP: "Animador",
};

// External test URLs (free, in Portuguese where available).
export const MBTI_TEST_URL = "https://www.16personalities.com/pt/teste-de-personalidade";
export const VIA_TEST_URL = "https://www.viacharacter.org/account/register";

// 4 official MBTI temperament groups (per 16personalities.com / Keirsey).
// Each entry: [pt_label, accent_color, [types...]].
export const MBTI_GROUPS = [
  {
    key: "analistas",
    label: "Analistas",
    sublabel: "Mentes estratégicas e analíticas",
    color: "#6D5BBA",
    types: ["INTJ", "INTP", "ENTJ", "ENTP"],
  },
  {
    key: "diplomatas",
    label: "Diplomatas",
    sublabel: "Idealistas focados em pessoas",
    color: "#33A474",
    types: ["INFJ", "INFP", "ENFJ", "ENFP"],
  },
  {
    key: "sentinelas",
    label: "Sentinelas",
    sublabel: "Práticos, leais e dedicados",
    color: "#3F8FCF",
    types: ["ISTJ", "ISFJ", "ESTJ", "ESFJ"],
  },
  {
    key: "exploradores",
    label: "Exploradores",
    sublabel: "Espontâneos e perspicazes",
    color: "#C9A227",
    types: ["ISTP", "ISFP", "ESTP", "ESFP"],
  },
];

// Reverse map: type → group key, for quick lookup in directory cards.
export const MBTI_TYPE_GROUP = Object.fromEntries(
  MBTI_GROUPS.flatMap((g) => g.types.map((t) => [t, g])),
);

// Official 24 VIA Character Strengths (https://www.viacharacter.org/)
export const VIA_STRENGTHS = {
  "Sabedoria & Conhecimento": [
    "Creativity", "Curiosity", "Judgment", "Love of Learning", "Perspective",
  ],
  "Coragem": [
    "Bravery", "Perseverance", "Honesty", "Zest",
  ],
  "Humanidade": [
    "Love", "Kindness", "Social Intelligence",
  ],
  "Justiça": [
    "Teamwork", "Fairness", "Leadership",
  ],
  "Temperança": [
    "Forgiveness", "Humility", "Prudence", "Self-Regulation",
  ],
  "Transcendência": [
    "Appreciation of Beauty", "Gratitude", "Hope", "Humor", "Spirituality",
  ],
};

export const VIA_FLAT = Object.values(VIA_STRENGTHS).flat();

export const VIA_TRANSLATIONS_PT = {
  "Creativity": "Criatividade",
  "Curiosity": "Curiosidade",
  "Judgment": "Discernimento",
  "Love of Learning": "Amor pela aprendizagem",
  "Perspective": "Perspetiva",
  "Bravery": "Coragem",
  "Perseverance": "Perseverança",
  "Honesty": "Honestidade",
  "Zest": "Vitalidade",
  "Love": "Amor",
  "Kindness": "Bondade",
  "Social Intelligence": "Inteligência social",
  "Teamwork": "Trabalho em equipa",
  "Fairness": "Justiça",
  "Leadership": "Liderança",
  "Forgiveness": "Perdão",
  "Humility": "Humildade",
  "Prudence": "Prudência",
  "Self-Regulation": "Autorregulação",
  "Appreciation of Beauty": "Apreciação da beleza",
  "Gratitude": "Gratidão",
  "Hope": "Esperança",
  "Humor": "Humor",
  "Spirituality": "Espiritualidade",
};

export const COUNTRIES_PT = [
  "Portugal", "Brasil", "Espanha", "França", "Alemanha",
  "Estados Unidos da América", "Argentina", "Chile", "Colômbia",
  "Itália", "Reino Unido", "Suíça", "Bélgica", "Holanda", "Outro",
];
